// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__36mwo","legacyBtn":"MutateMid_legacyBtn__pe2Qr"};